<div #parentContainer [style.pointer-events]="props.readonly ? 'none' : ''">
  <ng-container #fieldComponent></ng-container>
</div>
